<div class="loading-shade">
    <mat-spinner />
</div>
